export const COUNTRIES = [
    {id : 'AF', title: 'AF'},
    {id : 'AL', title: 'AL'},
    {id : 'DZ', title: 'DZ'},
    {id : 'AS', title: 'AS'},
    {id : 'AD', title: 'AD'},
    {id : 'AO', title: 'AO'},
    {id : 'AI', title: 'AI'},
    {id : 'AQ', title: 'AQ'},
    {id : 'AG', title: 'AG'},
    {id : 'AR', title: 'AR'},
    {id : 'AM', title: 'AM'},
    {id : 'AW', title: 'AW'},
    {id : 'AU', title: 'AU'},
    {id : 'AT', title: 'AT'},
    {id : 'AZ', title: 'AZ'},
    {id : 'BS', title: 'BS'},
    {id : 'BH', title: 'BH'},
    {id : 'BD', title: 'BD'},
    {id : 'BB', title: 'BB'},
    {id : 'BY', title: 'BY'},
    {id : 'BE', title: 'BE'},
    {id : 'BZ', title: 'BZ'},
    {id : 'BJ', title: 'BJ'},
    {id : 'BM', title: 'BM'},
    {id : 'BT', title: 'BT'},
    {id : 'BO', title: 'BO'},
    {id : 'BQ', title: 'BQ'},
    {id : 'BA', title: 'BA'},
    {id : 'BW', title: 'BW'},
    {id : 'BV', title: 'BV'},
    {id : 'BR', title: 'BR'},
    {id : 'IO', title: 'IO'},
    {id : 'BN', title: 'BN'},
    {id : 'BG', title: 'BG'},
    {id : 'BF', title: 'BF'},
    {id : 'BI', title: 'BI'},
    {id : 'CV', title: 'CV'},
    {id : 'KH', title: 'KH'},
    {id : 'CM', title: 'CM'},
    {id : 'CA', title: 'CA'},
    {id : 'KY', title: 'KY'},
    {id : 'CF', title: 'CF'},
    {id : 'TD', title: 'TD'},
    {id : 'CL', title: 'CL'},
    {id : 'CN', title: 'CN'},
    {id : 'CX', title: 'CX'},
    {id : 'CC', title: 'CC'},
    {id : 'CO', title: 'CO'},
    {id : 'KM', title: 'KM'},
    {id : 'CD', title: 'CD'},
    {id : 'CG', title: 'CG'},
    {id : 'CK', title: 'CK'},
    {id : 'CR', title: 'CR'},
    {id : 'HR', title: 'HR'},
    {id : 'CU', title: 'CU'},
    {id : 'CW', title: 'CW'},
    {id : 'CY', title: 'CY'},
    {id : 'CZ', title: 'CZ'},
    {id : 'CI', title: 'CI'},
    {id : 'DK', title: 'DK'},
    {id : 'DJ', title: 'DJ'},
    {id : 'DM', title: 'DM'},
    {id : 'DO', title: 'DO'},
    {id : 'EC', title: 'EC'},
    {id : 'EG', title: 'EG'},
    {id : 'SV', title: 'SV'},
    {id : 'GQ', title: 'GQ'},
    {id : 'ER', title: 'ER'},
    {id : 'EE', title: 'EE'},
    {id : 'SZ', title: 'SZ'},
    {id : 'ET', title: 'ET'},
    {id : 'FK', title: 'FK'},
    {id : 'FO', title: 'FO'},
    {id : 'FJ', title: 'FJ'},
    {id : 'FI', title: 'FI'},
    {id : 'FR', title: 'FR'},
    {id : 'GF', title: 'GF'},
    {id : 'PF', title: 'PF'},
    {id : 'TF', title: 'TF'},
    {id : 'GA', title: 'GA'},
    {id : 'GM', title: 'GM'},
    {id : 'GE', title: 'GE'},
    {id : 'DE', title: 'DE'},
    {id : 'GH', title: 'GH'},
    {id : 'GI', title: 'GI'},
    {id : 'GR', title: 'GR'},
    {id : 'GL', title: 'GL'},
    {id : 'GD', title: 'GD'},
    {id : 'GP', title: 'GP'},
    {id : 'GU', title: 'GU'},
    {id : 'GT', title: 'GT'},
    {id : 'GG', title: 'GG'},
    {id : 'GN', title: 'GN'},
    {id : 'GW', title: 'GW'},
    {id : 'GY', title: 'GY'},
    {id : 'HT', title: 'HT'},
    {id : 'HM', title: 'HM'},
    {id : 'VA', title: 'VA'},
    {id : 'HN', title: 'HN'},
    {id : 'HK', title: 'HK'},
    {id : 'HU', title: 'HU'},
    {id : 'IS', title: 'IS'},
    {id : 'IN', title: 'IN'},
    {id : 'ID', title: 'ID'},
    {id : 'IR', title: 'IR'},
    {id : 'IQ', title: 'IQ'},
    {id : 'IE', title: 'IE'},
    {id : 'IM', title: 'IM'},
    {id : 'IL', title: 'IL'},
    {id : 'IT', title: 'IT'},
    {id : 'JM', title: 'JM'},
    {id : 'JP', title: 'JP'},
    {id : 'JE', title: 'JE'},
    {id : 'JO', title: 'JO'},
    {id : 'KZ', title: 'KZ'},
    {id : 'KE', title: 'KE'},
    {id : 'KI', title: 'KI'},
    {id : 'KP', title: 'KP'},
    {id : 'KR', title: 'KR'},
    {id : 'KW', title: 'KW'},
    {id : 'KG', title: 'KG'},
    {id : 'LA', title: 'LA'},
    {id : 'LV', title: 'LV'},
    {id : 'LB', title: 'LB'},
    {id : 'LS', title: 'LS'},
    {id : 'LR', title: 'LR'},
    {id : 'LY', title: 'LY'},
    {id : 'LI', title: 'LI'},
    {id : 'LT', title: 'LT'},
    {id : 'LU', title: 'LU'},
    {id : 'MO', title: 'MO'},
    {id : 'MG', title: 'MG'},
    {id : 'MW', title: 'MW'},
    {id : 'MY', title: 'MY'},
    {id : 'MV', title: 'MV'},
    {id : 'ML', title: 'ML'},
    {id : 'MT', title: 'MT'},
    {id : 'MH', title: 'MH'},
    {id : 'MQ', title: 'MQ'},
    {id : 'MR', title: 'MR'},
    {id : 'MU', title: 'MU'},
    {id : 'YT', title: 'YT'},
    {id : 'MX', title: 'MX'},
    {id : 'FM', title: 'FM'},
    {id : 'MD', title: 'MD'},
    {id : 'MC', title: 'MC'},
    {id : 'MN', title: 'MN'},
    {id : 'ME', title: 'ME'},
    {id : 'MS', title: 'MS'},
    {id : 'MA', title: 'MA'},
    {id : 'MZ', title: 'MZ'},
    {id : 'MM', title: 'MM'},
    {id : 'NA', title: 'NA'},
    {id : 'NR', title: 'NR'},
    {id : 'NP', title: 'NP'},
    {id : 'NL', title: 'NL'},
    {id : 'NC', title: 'NC'},
    {id : 'NZ', title: 'NZ'},
    {id : 'NI', title: 'NI'},
    {id : 'NE', title: 'NE'},
    {id : 'NG', title: 'NG'},
    {id : 'NU', title: 'NU'},
    {id : 'NF', title: 'NF'},
    {id : 'MP', title: 'MP'},
    {id : 'NO', title: 'NO'},
    {id : 'OM', title: 'OM'},
    {id : 'PK', title: 'PK'},
    {id : 'PW', title: 'PW'},
    {id : 'PS', title: 'PS'},
    {id : 'PA', title: 'PA'},
    {id : 'PG', title: 'PG'},
    {id : 'PY', title: 'PY'},
    {id : 'PE', title: 'PE'},
    {id : 'PH', title: 'PH'},
    {id : 'PN', title: 'PN'},
    {id : 'PL', title: 'PL'},
    {id : 'PT', title: 'PT'},
    {id : 'PR', title: 'PR'},
    {id : 'QA', title: 'QA'},
    {id : 'MK', title: 'MK'},
    {id : 'RO', title: 'RO'},
    {id : 'RU', title: 'RU'},
    {id : 'RW', title: 'RW'},
    {id : 'RE', title: 'RE'},
    {id : 'BL', title: 'BL'},
    {id : 'SH', title: 'SH'},
    {id : 'KN', title: 'KN'},
    {id : 'LC', title: 'LC'},
    {id : 'MF', title: 'MF'},
    {id : 'PM', title: 'PM'},
    {id : 'VC', title: 'VC'},
    {id : 'WS', title: 'WS'},
    {id : 'SM', title: 'SM'},
    {id : 'ST', title: 'ST'},
    {id : 'SA', title: 'SA'},
    {id : 'SN', title: 'SN'},
    {id : 'RS', title: 'RS'},
    {id : 'SC', title: 'SC'},
    {id : 'SL', title: 'SL'},
    {id : 'SG', title: 'SG'},
    {id : 'SX', title: 'SX'},
    {id : 'SK', title: 'SK'},
    {id : 'SI', title: 'SI'},
    {id : 'SB', title: 'SB'},
    {id : 'SO', title: 'SO'},
    {id : 'ZA', title: 'ZA'},
    {id : 'GS', title: 'GS'},
    {id : 'SS', title: 'SS'},
    {id : 'ES', title: 'ES'},
    {id : 'LK', title: 'LK'},
    {id : 'SD', title: 'SD'},
    {id : 'SR', title: 'SR'},
    {id : 'SJ', title: 'SJ'},
    {id : 'SE', title: 'SE'},
    {id : 'CH', title: 'CH'},
    {id : 'SY', title: 'SY'},
    {id : 'TW', title: 'TW'},
    {id : 'TJ', title: 'TJ'},
    {id : 'TZ', title: 'TZ'},
    {id : 'TH', title: 'TH'},
    {id : 'TL', title: 'TL'},
    {id : 'TG', title: 'TG'},
    {id : 'TK', title: 'TK'},
    {id : 'TO', title: 'TO'},
    {id : 'TT', title: 'TT'},
    {id : 'TN', title: 'TN'},
    {id : 'TR', title: 'TR'},
    {id : 'TM', title: 'TM'},
    {id : 'TC', title: 'TC'},
    {id : 'TV', title: 'TV'},
    {id : 'UG', title: 'UG'},
    {id : 'UA', title: 'UA'},
    {id : 'AE', title: 'AE'},
    {id : 'GB', title: 'GB'},
    {id : 'UM', title: 'UM'},
    {id : 'US', title: 'US'},
    {id : 'UY', title: 'UY'},
    {id : 'UZ', title: 'UZ'},
    {id : 'VU', title: 'VU'},
    {id : 'VE', title: 'VE'},
    {id : 'VN', title: 'VN'},
    {id : 'VG', title: 'VG'},
    {id : 'VI', title: 'VI'},
    {id : 'WF', title: 'WF'},
    {id : 'EH', title: 'EH'},
    {id : 'YE', title: 'YE'},
    {id : 'ZM', title: 'ZM'},
    {id : 'ZW', title: 'ZW'},
    {id : 'AX', title: 'AX'},
]

export const TIME_ZONES = [
{id: 'GMT', title: 'Greenwich Mean Time	GMT'},
{id: 'UTC', title: 'Universal Coordinated Time	GMT'},
{id: 'ECT', title: 'European Central Time	GMT+1:00'},
{id: 'EET', title: 'Eastern European Time	GMT+2:00'},
{id: 'ART', title: '(Arabic) Egypt Standard Time	GMT+2:00'},
{id: 'EAT', title: 'Eastern African Time	GMT+3:00'},
{id: 'MET', title: 'Middle East Time	GMT+3:30'},
{id: 'NET', title: 'Near East Time	GMT+4:00'},
{id: 'PLT', title: 'Pakistan Lahore Time	GMT+5:00'},
{id: 'IST', title: 'India Standard Time	GMT+5:30'},
{id: 'BST', title: 'Bangladesh Standard Time	GMT+6:00'},
{id: 'VST', title: 'Vietnam Standard Time	GMT+7:00'},
{id: 'CTT', title: 'China Taiwan Time	GMT+8:00'},
{id: 'JST', title: 'Japan Standard Time	GMT+9:00'},
{id: 'ACT', title: 'Australia Central Time	GMT+9:30'},
{id: 'AET', title: 'Australia Eastern Time	GMT+10:00'},
{id: 'SST', title: 'Solomon Standard Time	GMT+11:00'},
{id: 'NST', title: 'New Zealand Standard Time	GMT+12:00'},
{id: 'MIT', title: 'Midway Islands Time	GMT-11:00'},
{id: 'HST', title: 'Hawaii Standard Time	GMT-10:00'},
{id: 'AST', title: 'Alaska Standard Time	GMT-9:00'},
{id: 'PST', title: 'Pacific Standard Time	GMT-8:00'},
{id: 'PNT', title: 'Phoenix Standard Time	GMT-7:00'},
{id: 'MST', title: 'Mountain Standard Time	GMT-7:00'},
{id: 'CST', title: 'Central Standard Time	GMT-6:00'},
{id: 'EST', title: 'Eastern Standard Time	GMT-5:00'},
{id: 'IET', title: 'Indiana Eastern Standard Time	GMT-5:00'},
{id: 'PRT', title: 'Puerto Rico and US Virgin Islands Time	GMT-4:00'},
{id: 'CNT', title: 'Canada Newfoundland Time	GMT-3:30'},
{id: 'AGT', title: 'Argentina Standard Time	GMT-3:00'},
{id: 'BET', title: 'Brazil Eastern Time	GMT-3:00'},
{id: 'CAT', title: 'Central African Time	GMT-1:00'},
]